import React, { useEffect, useState } from 'react'
import { videoApi } from '@services/api'
import { toast } from 'react-toastify'
import ListVideoComponent from './ListVideoComponent'

const limit = 6

const ListRecentlyPostedVideo: React.FC<any> = ({
  onSelectVideo
}) => {
  const [videos, setVideos] = useState([] as any[])
  const [page, setPage] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!(page === 1 && videos.length > 0)) {
      fetchVideos()
    }
  }, [page]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchVideos = async () => {
    try {
      setLoading(true)
      const params = {
        PageIndex: page,
        PageSize: limit
      }
      const res = await videoApi.fetchRecentlyPostedVideos(params)
      if (res && res.success) {
        setVideos([...videos, ...res.data])
        setHasNextPage(res.hasNextPage)
      }
      setLoading(false)
    } catch (error) {
      toast.error('Error while getting recently posted video')
      setLoading(false)
    }
  }

  const onResetListVideo = () => {
    setPage(1)
    setVideos(videos.slice(0, limit))
    setHasNextPage(true)
  }

  return (
    <ListVideoComponent
      videos={videos}
      page={page}
      setPage={setPage}
      hasNextPage={hasNextPage}
      loading={loading}
      title={(
        <>
          <span className="text-red">NEW !</span> 最新投稿動画
        </>
      )}
      onSelectVideo={onSelectVideo}
      onResetListVideo={onResetListVideo}
    />
  )
}

export default ListRecentlyPostedVideo
